import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@material-ui/core';
import Container from '../../components/Container'
import Typo from '../../components/CustomTypo';
import { getContacts } from '../../utils/common';


const styles = theme => ({
    account_balance: {
        backgroundColor: theme.palette.background.primary,
        borderRadius: theme.shape.borderRadius2x,
        padding: theme.spacing(4),
        marginBottom: theme.spacing(3),
    },
    balance: {
        marginTop: theme.spacing(3),
    },
    filter: {
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(3),
        padding: theme.spacing(3),
    },
    table_data: {
        // backgroundColor: theme.palette.background.primary,
        // borderRadius: theme.spacing(3),
        // padding: theme.spacing(3),
        margin: theme.spacing(4, 0),
    },
    credit: {
        color: theme.palette.button.success.color,
        fontWeight: 'bold',
    },
    debit: {
        color: theme.palette.background.primary,
        fontWeight: 'bold',
    },
    table_row: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    filter_status: {
        [theme.breakpoints.down('lg')]: {
            padding: theme.spacing(3, 0),
        },
    },
    title_status: {
        [theme.breakpoints.up('lg')]: {
            marginLeft: theme.spacing(3) + 'px!important'
        }
    },
    //input
    inputRoot: {
        border: '1px solid',
        borderColor: theme.palette.border.secondary,
        borderRadius: 24,
        height: 48,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.secondary,
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        marginTop: theme.spacing(1),
        position: 'relative'
    },
    inputLine: {
        width: '100%',
        // marginTop: theme.spacing(2),
    },
    form: {
        textAlign: 'center',
        justifyContent: 'center',
    },
});

function WalletView(props) {
    const { t, classes, currency, wallet } = props;

    let crmWallet = wallet.find(wallet => wallet.type === "CRM");
    let crmTotal = crmWallet ? crmWallet.total : 0.00;
    let businessWallet = wallet.find(wallet => wallet.type === "BUSINESS");
    let businessOpen = businessWallet ? businessWallet.open : 0.00;
    let businessCommerce = businessWallet ? businessWallet.commerce : 0.00;
    let totalBalance = crmTotal + businessOpen;
    return (
        <Container>
            <Grid item xs={12}>
                <Grid item xs={12} sm={6}>
                    <Grid xs={12} item className={classes.account_balance}>
                        <Grid item xs={12} container alignItems='center' className={classes.balance}>
                            <Grid item xs={6}>
                                <Typo variant='h6' color='onPrimary'>Wallet Balance</Typo>
                            </Grid>
                            <Grid item xs={6} >
                                <Typo variant="h6" color="onPrimary">{currency}{totalBalance.toFixed(2)}</Typo>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container alignItems='center' className={classes.balance}>
                            <Grid item xs={6}>
                                <Typo variant="h6" color="onPrimary">Commerce Pocket</Typo>
                            </Grid>
                            <Grid item xs={6}>
                                <Typo variant="h6" color="onPrimary">{currency}{businessCommerce.toFixed(2)}</Typo>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container >
    );
}

export default withStyles(styles)(withTranslation()(WalletView));
